import { l } from '../../lib/imports'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { echoFonts } from '../echo/echoFonts-sidecar'
import { EJumpCommand } from './multi/voyageMessageJump'
import { voyageMessageJump } from './multi/voyageMessageJump-sidecar'

import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import type { IVoyageUiCanvas } from './voyageUiCanvas'
import { voyageUiCanvas } from './voyageUiCanvas-sidecar'
import { voyageUiGButtons } from './voyageUiGButtons-sidecar'
import { voyageUiGraphicsUtils } from './voyageUiGraphicsUtils-sidecar'
import type { IVoyageNavData } from './voyageUiNav_data'
import { voyageUiNav_data } from './voyageUiNav_data-sidecar'

let _needsRefresh = true
let _lastLocationName = 'unknown'
interface IVoyageUiNav extends IVoyageUiCanvas {}

let _obj: IVoyageUiNav | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(false)
    render()
  }
  return _obj
}

const create = () => {
  let tw = 700
  let th = 800
  let canvas = voyageUiCanvas.create(tw, th, voyageLayers.getLayers().uiMenu)
  canvas.ox = 0
  canvas.oy = 0

  let obj: IVoyageUiNav = voyageUiCanvas.assign<IVoyageUiNav>(canvas, {})

  return obj
}

// TODO: add potential locations
const updateList = (list: IVoyageNavData[]) => {
  let x = 20
  let y = 40
  let obj = get()
  const addButton = (text: string, action: () => void) => {
    let button = voyageUiGButtons.create(text, x, y, action)

    button.w = 200
    obj.buttons.push(button)
    y += 60
    if (y > obj.targetHeight - 60) {
      x += 200 + 20
      y = 40
    }
  }

  obj.buttons = []

  let status = voyageGameStatus.get()
  l.forEach(list, (c) => {
    if (c.locationName === status.locationName) {
      return
    }
    addButton(c.locationName, () => {
      if (status.jump >= 98) {
        voyageMessageJump.sendMessageRequest({
          command: EJumpCommand.Request,
          isStarbase: c.isStarbase,
          locationName: c.locationName,
        })
        setOpen(false)
      } else {
        voyageSounds.playFailure()
      }
    })
  })

  y += 60
  addButton('Cancel', () => {
    setOpen(false)
  })
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  voyageUiCanvas.clear(obj)
  if (!obj.isOpen) {
    return
  }

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(echoFonts.getData().font6, x, y, obj.layer)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 3)

    obj.texts.push(_text)
    return _text
  }

  let x = 0
  let y = 0
  let w = obj.targetWidth
  let h = obj.targetHeight

  voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h)
  addText('Nav to', x + 6, y) // + 25 - 2)

  x = 400
  y = 60

  let status = voyageGameStatus.get()
  addText('Jump drive ' + status.jump + '%', x, y)
  y += 20
  addText('At ' + status.locationName, x, y)
  y += 20
  // let b = obj.selectedBattle
  // if (b) {
  //   addText(b.name, x, y)
  //   y += 40
  //   addText(b.desc, x, y)
  //   y += 40
  //   addText('Budget: $' + b.budget, x, y)
  // }

  voyageUiCanvas.render(obj)
}

export const setOpen = (isOpen: boolean) => {
  let obj = get()

  if (isOpen && !obj.isOpen) {
    // voyageJsonServerInterface.list((list) => {
    //   updateList(list)
    // })
    // updateList(voyageUiBuyStuff_data.dataList) //['crew', 'fire extinguisher', 'wrench', 'torpedo'])
  }

  voyageUiCanvas.setOpen(obj, isOpen)
  update()
}

export const update = () => {
  let obj = get()

  let status = voyageGameStatus.get()
  if (_lastLocationName !== status.locationName) {
    _needsRefresh = true
    _lastLocationName = status.locationName
  }

  if (obj.isOpen) {
    if (_needsRefresh) {
      updateList(voyageUiNav_data.navLocations) //['crew', 'fire extinguisher', 'wrench', 'torpedo'])
      _needsRefresh = false
    }
  }

  voyageUiCanvas.update(obj)
  render()
}
